import React, { useState, useEffect, useRef, useMemo } from 'react';
import Divider from '@mui/material/Divider';
import { useDraggable } from "react-use-draggable-scroll";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import IntervalService from './../../services/intervals';
import Waiting from '../items/Waiting';
import { Views } from './../../enums/enums';
import { useMediaQuery } from 'react-responsive';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Grid from '@mui/material/Grid';
import RefreshIcon from '@mui/icons-material/Refresh';
import TrackListContainer from '../items/TrackListContainer';
import TR from '../../Trans';
import ContentContainer from '../items/ContentContainer';
import { checkIfMobile } from '../../services/screen';
import ArrowButton from '../items/ArrowButton';
import muvikaAttrs from './../../attrs';
import Accordion from '@mui/material/Accordion';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import TrackListScroller from '../items/TrackListScroller';
import MuvikaService from './../../services/muvika';
import ChangePlayList from './../dialogs/ChangePlayList';
import HorizontalContainer from '../items/HorizontalContainer';
import HorizontalListItem from '../items/HorizontalListItem';
import Carousel from 'react-material-ui-carousel';
import Stack from '@mui/material/Stack';
import AddPerformance from '../dialogs/AddPerformance';
import CopyPlayList from '../dialogs/CopyPlayList';
import ChangeTrackPerformance from '../dialogs/ChangeTrackPerformance';
import NewsListItem from '../items/NewsListItem';
import sessionStore from '../../stores/session';
import newsStore from '../../stores/news';
import messageStore from './../../stores/message';
import homeStore from '../../stores/home';
import playerStore from '../../stores/player';
import singersStore from '../../stores/singers';
import performanceStore from '../../stores/performance';
import settingsStore from '../../stores/settings';
import accountStore from '../../stores/account';
import navigationStore from '../../stores/navigation';

const newsTheme = createTheme({
  components: {
    MuiIconButton: {
      defaultProps: {
        disableRipple: true,
        disableFocusRipple: true,
      },
      styleOverrides: {
        root: {
          backgroundColor: "var(--bg-color) !important",
          color: "#fff !important",
          boxShadow: "none !important",
          transition: "none !important",
          "&:hover, &:focus, &:active": {
            backgroundColor: "var(--bg-color) !important",
            color: "#fff !important",
            boxShadow: "none !important",
          },
          "&::before, &::after": {
            display: "none !important",
          },
        },
      },
    },
    MuiTouchRipple: {
      styleOverrides: {
        root: {
          display: "none",
        },
      },
    },
  },
});

const timeout24h = 1000 * 60 * 60 * 24;

function Home() {
  const itemsOnPage = 50;
  const sessionToken = sessionStore((state) => state.sessionToken);
  const isSet = newsStore((state) => state.isSet);
  const isWaiting = newsStore((state) => state.isWaiting);
  const news = newsStore((state) => state.news);
  const setError = messageStore((state) => state.setError);
  const performanceToBeChanged = performanceStore((state) => state.performanceToBeChanged);
  const changeTrackPerformance = performanceStore((state) => state.changeTrackPerformance);
  const getNews = newsStore((state) => state.getNews);
  const getNewsMore = newsStore((state) => state.getNewsMore);
  const isFinished = newsStore((state) => state.isFinished);
  const trendingTracks = homeStore((state) => state.trendingTracks);
  const publicPlaylists = homeStore((state) => state.publicPlaylists);
  const getTrendingTracks = homeStore((state) => state.getTrendingTracks);
  const getPublicPlaylists = homeStore((state) => state.getPublicPlaylists);
  const addPerformanceToPlayQueue = performanceStore((state) => state.addPerformanceToPlayQueue);
  const addPerformanceToPlayList = performanceStore((state) => state.addPerformanceToPlayList);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const getSingers = singersStore((state) => state.getSingers);
  const singers = singersStore((state) => state.singers);
  const playLists = performanceStore((state) => state.playLists);
  const getPlayLists = performanceStore((state) => state.getPlayLists);
  const isPlaying = playerStore((state) => state.isPlaying);
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const account = accountStore((state) => state.account);
  const getAccount = accountStore((state) => state.getAccount);
  const setIsSwitching = playerStore((state) => state.setIsSwitching);
  const playQueue = performanceStore((state) => state.playQueue);
  const setCurrentPlayListPublic = performanceStore((state) => state.setCurrentPlayListPublic);
  const addPlayListToTheEndPublic = performanceStore((state) => state.addPlayListToTheEndPublic);
  const copyPlayList = performanceStore((state) => state.copyPlayList);
  const resetNews = newsStore((state) => state.resetNews);
  const isNewsOn = navigationStore((state) => state.isNewsOn);
  const toggleNews = navigationStore((state) => state.toggleNews);
  const setNewsVisible = navigationStore((state) => state.setNewsVisible);
  const setMobilePlayerVisible = navigationStore((state) => state.setMobilePlayerVisible);
  const goToView = navigationStore((state) => state.goToView);
  const accountLang = accountStore((state) => state.account?.language);

  useEffect(() => {}, [accountLang]);

  const isMobile = useMediaQuery({ query: '(max-width: 720px)' });

  const [chosenTrack, setChosenTrack] = useState({});
  const [isAddPerformanceOpen, setIsAddPerformanceOpen] = useState(false);
  const [isChangeTrackPerformanceOpen, setIsChangeTrackPerformanceOpen] = useState(false);
  const [chosenPublicPlaylist, setChosenPublicPlaylist] = useState(null);
  const [isChangePlayListOpen, setIsChangePlayListOpen] = useState(false);
  const [isCopyPlayListOpen, setIsCopyPlayListOpen] = useState(false);

  const handleOpenCopyPlayList = () => {
    setIsCopyPlayListOpen(true);
  };

  const handleCloseCopyPlayList = () => {
    setIsCopyPlayListOpen(false);
  };

  const handleOpenChangePlayList = () => {
    setIsChangePlayListOpen(true);
  };

  const handleCloseChangePlayList = () => {
    setIsChangePlayListOpen(false);
  };

  const handleReplacePlayList = () => {
    setIsAutoPlayOn(true);
    IntervalService.clearAllIntervals();
    setCurrentPlayListPublic(sessionToken, chosenPublicPlaylist, singers[0]);
    handleCloseChangePlayList();
  };

  const handleAddPlayListToEnd = () => {
    setIsAutoPlayOn(true);
    if (playQueue) {
      if (playQueue.items.length == 0) {
        IntervalService.clearAllIntervals();
      }
    }
    console.log("chosen", chosenPublicPlaylist.items);
    addPlayListToTheEndPublic(sessionToken, chosenPublicPlaylist, singers[0]);
    handleCloseChangePlayList();
  };

  const handleOpenAddPerformance = (track) => {
    MuvikaService.getLastPerformance(sessionToken, track.track_id)
      .then(function (res) {
        if (res.data.error) {
          setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          if (res.data.data.profile_id) {
            track.last_pitch = res.data.data.pitch;
            track.last_singer_id = res.data.data.profile_id;
          }
          setChosenTrack(track);
          setIsAddPerformanceOpen(true);
        }
      })
      .catch(function () { });
  };

  const handleCloseAddPerformance = () => {
    setIsAddPerformanceOpen(false);
  };

  const handleOpenChangePerformance = (track) => {
    if (performanceToBeChanged) {
      MuvikaService.getLastPerformance(sessionToken, track.track_id)
        .then(function (res) {
          if (res.data.error) {
            setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            if (res.data.data.profile_id) {
              track.last_pitch = res.data.data.pitch;
            }
            track.last_singer_id = performanceToBeChanged.profile.id;
            setChosenTrack(track);
            setIsChangeTrackPerformanceOpen(true);
          }
        })
        .catch(function () { });
    }
  };

  const handleCloseChangeTrackPerformance = () => {
    setIsChangeTrackPerformanceOpen(false);
  };

  const handleScrollDown = () => {
    getNewsMore(sessionToken, itemsOnPage);
  };

  useEffect(() => {
    if (!singers) {
      getSingers(sessionToken);
    }
    if (!playLists) {
      getPlayLists(sessionToken);
    }
    if (!settings) {
      getSettings(sessionToken);
    }
    if (!news) {
      getNews(sessionToken, itemsOnPage);
    }
    if (!trendingTracks) {
      getTrendingTracks(sessionToken, itemsOnPage);
    }
    if (!publicPlaylists) {
      getPublicPlaylists(sessionToken);
    }
    if (!account) {
      getAccount(sessionToken);
    }
    setTimeout(handleRefresh, timeout24h);
  }, []);

  useEffect(() => {
    if (news) {
      if (news.length > 0) {
        const savedNewsLastPub = localStorage.getItem(muvikaAttrs.service + "-new-last-published");
        const savedNewsLastPubValue = JSON.parse(savedNewsLastPub);
        if (savedNewsLastPubValue) {
          let lastPub = new Date(savedNewsLastPubValue);
          let newsPub = new Date(news[0].published);
          if (lastPub >= newsPub) {
            setNewsVisible(false);
          } else {
            setNewsVisible(true);
          }
        }
      }
    }
  }, [news]);

  const handleChangeTrackPerformance = (singerProfile, pitch) => {
    if (singerProfile && (pitch >= -3 && pitch <= 3)) {
      changeTrackPerformance(sessionToken, chosenTrack, singerProfile, pitch);
      setIsChangeTrackPerformanceOpen(false);
    } else {
      setError(sessionToken, 0, TR.cm_select_singer);
    }
  };

  const handleAddPerformance = (singerProfile, pitch, playList, toPos, isManual, playNow = false, isSongbookQueue = false) => {
    if (singerProfile && (pitch >= -3 && pitch <= 3)) {
      if (playList) {
        addPerformanceToPlayList(sessionToken, chosenTrack, singerProfile, pitch, playList.id, toPos);
        setIsAddPerformanceOpen(false);
      } else {
        if (isSongbookQueue) {
          MuvikaService.createSongRequest(sessionToken, "add", chosenTrack.track_id, singerProfile.id, pitch, [])
            .then(function (res) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              }
            })
            .catch(function () { });
          setIsAddPerformanceOpen(false);
        } else {
          setIsAutoPlayOn(settings.autoplay_enabled);
          addPerformanceToPlayQueue(sessionToken, chosenTrack, singerProfile, pitch, toPos, isManual, playNow);
          setIsAddPerformanceOpen(false);
        }
      }
      if (toPos == 0 && playNow) {
        IntervalService.clearAllIntervals();
        setIsAutoPlayOn(false);
        setIsSwitching(true);
        let isMobile = checkIfMobile();
        if (isMobile) {
          goToView(Views.Blank);
          setMobilePlayerVisible(true);
        }
      }
    } else {
      setError(sessionToken, 0, TR.cm_select_singer);
    }
  };

  const handleRefresh = () => {
    setChosenTrack({});
    setChosenPublicPlaylist(null);
    resetNews();
    homeStore.getState().reset();
    setTimeout(() => {
      getNews(sessionToken, itemsOnPage);
      getTrendingTracks(sessionToken, itemsOnPage);
      getPublicPlaylists(sessionToken);
    }, 500);
  };

  const handlePlayListCopy = (playListName) => {
    if (playListName.length > 0) {
      copyPlayList(sessionToken, chosenPublicPlaylist, playListName);
    }
    setIsCopyPlayListOpen(false);
  };

  const newsList = () => {
    if (news) {
      return news.map((newsItem, index) =>
        <NewsListItem key={index} isOpen={index == 0} newsItem={newsItem} />
      );
    }
  };

  const waitingRender = () => {
    if (isWaiting) {
      return <Waiting />;
    }
  };

  const renderTopTracks = () => {
    if (trendingTracks) {
      return trendingTracks.map((track, index) => {

        return <HorizontalListItem
          id={"muvika-top-track-" + index}
          key={index}
          image={track.url_cover_image}
          primary={track.title}
          secondary={track.artist}
          onClick={(e) => {

            e.preventDefault();
            if (performanceToBeChanged) {
              handleOpenChangePerformance(track);
            } else {
              handleOpenAddPerformance(track);
            }
          }}
        />;
      });
    }
  };

  const scrollDownwards = () => {
    setTimeout(() => {
      let containerEle = document.getElementById("muvika-home");
      if (containerEle) {
        containerEle.scrollBy({
          top: 200,
          left: 0,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const renderPublicPlaylists = () => {
    if (publicPlaylists) {
      return publicPlaylists.map((playlist, index) => {

        return <HorizontalListItem
          key={index}
          isChosen={chosenPublicPlaylist ? chosenPublicPlaylist.name === playlist.name : false}
          image={playlist.url_cover_image}
          primary={playlist.name}
          info={playlist.info}
          secondary={""}
          onClick={(e) => {
            setChosenPublicPlaylist(playlist);
          }}
        />;
      });
    }
  };

  const renderChangeTrackDialog = () => {
    if (performanceToBeChanged) {
      return <ChangeTrackPerformance
        open={isChangeTrackPerformanceOpen}
        onClose={handleCloseChangeTrackPerformance}
        track={chosenTrack}
        performance={performanceToBeChanged}
        onChangeTrackPerformance={handleChangeTrackPerformance}
        singers={singers}
      />;
    }
  };

  const renderPlaylistButtons = () => {
    if (chosenPublicPlaylist) {
      return <Stack direction="row" spacing={0} justifyContent={"right"}>
        <IconButton onClick={() => {
          handleOpenCopyPlayList();
        }}>
          <ContentCopyIcon />
        </IconButton>
        <IconButton onClick={() => {
          handleOpenChangePlayList();
        }}>
          <PlayArrowIcon />
        </IconButton>
      </Stack>;
    }
  };

  const chosenPlayListTrackList = useMemo(() => {
    if (!chosenPublicPlaylist) return [];

    return chosenPublicPlaylist.items
      .map((performance) => performance.track)
      .reduce((acc, track) => {
        if (!acc.some(t => t.track_id === track.track_id)) {
          acc.push(track);
        }
        return acc;
      }, []);
  }, [chosenPublicPlaylist]);

  const renderTrackList = () => {
    if (chosenPublicPlaylist) {
      return <div>
        <Grid container spacing={0}>
          <Grid item xs={11.5}>
            <h3>{chosenPublicPlaylist.name} <span className="muvika-home-public-playlist-info">{chosenPublicPlaylist.info}</span></h3>
          </Grid>
          <Grid item xs={0.5} justifyContent={"right"}>
            {renderPlaylistButtons()}
          </Grid>
        </Grid>
        <TrackListContainer playListId={chosenPublicPlaylist.id} isOnFavoritesView={false} isSongbook={false} isNewTracks={false} tracks={chosenPlayListTrackList} />
      </div>;
    }
  };

  const renderExpandButton = () => {
    if (isNewsOn) {
      return <IconButton className="muvika-button-stack" color="white" component="label" onClick={() => {
        localStorage.setItem(muvikaAttrs.service + "-new-last-published", JSON.stringify(news[0].published));
        toggleNews();
      }}>
        <ExpandLessIcon />
      </IconButton>;
    } else {
      return <IconButton className="muvika-button-stack" color="white" component="label" onClick={() => {
        localStorage.setItem(muvikaAttrs.service + "-new-last-published", null);
        toggleNews();
      }}>
        <ExpandMoreIcon />
      </IconButton>;
    }
  };

  return (
    <div>
      <AddPerformance
        open={isAddPerformanceOpen}
        onClose={handleCloseAddPerformance}
        onAddPerformance={handleAddPerformance}
        track={chosenTrack}
        singers={singers}
        isPlaying={isPlaying.isPlaying}
        playLists={playLists}
        playQueue={playQueue}
      />
      <ChangePlayList
        openToLeft={true}
        isEmpty={playQueue ? playQueue.items.length == 0 : false}
        open={isChangePlayListOpen}
        onClose={handleCloseChangePlayList}
        onReplace={handleReplacePlayList}
        onAddToEnd={handleAddPlayListToEnd}
      />
      <CopyPlayList
        openToLeft={true}
        open={isCopyPlayListOpen}
        playListName={chosenPublicPlaylist ? chosenPublicPlaylist.name : ""}
        onClose={handleCloseCopyPlayList}
        onPlayListCopy={handlePlayListCopy}
      />
      {renderChangeTrackDialog()}
      <ContentContainer id="muvika-home" onScrollDown={() => {
      }} isFinished={true} isSongbook={false}>
        <Grid container spacing={0}>
          <Grid item xs={11}>
            <Stack direction={"row"}>
              <h3>{TR.cm_news}</h3>
              {renderExpandButton()}
            </Stack>
          </Grid>
          <Grid item xs={1}>
            <IconButton className="muvika-button-right" color="white" component="label" onClick={handleRefresh}>
              <RefreshIcon />
            </IconButton>
          </Grid>
        </Grid>
        <ThemeProvider theme={newsTheme}>
          <Carousel
            autoPlay={false}
            navButtonsAlwaysVisible
            // ❌ Removes ripple and focus styles
            navButtonsProps={{
              disableRipple: true,
              disableFocusRipple: true,
              sx: {
                display: isNewsOn ? "block" : "none",
                backgroundColor: "var(--bg-color)",
                color: "#fff",
                boxShadow: "none",
                transition: "none !important",
                opacity: "0.8 !important",
                "&:hover": {
                  backgroundColor: "var(--bg-color)",
                  opacity: "0.8 !important",
                },
              },
            }}
            // ✅ Forces wrapper to stay visible (no fade on hover)
            navButtonsWrapperProps={{
              sx: {
                opacity: "0.8 !important",
                transition: "none !important",
                "&:hover": {
                  opacity: "0.8 !important",
                },
              },
            }}
            // ✅ Kills fade behavior applied to the entire carousel
            sx={{
              display: isNewsOn ? "block" : "none",
              "&:hover .MuiButtonBase-root": {
                opacity: "0.8 !important",
              },
              "& .MuiButtonBase-root": {
                opacity: "0.8 !important",
                transition: "none !important",
              },
              "& .MuiButtonBase-root *": {
                transition: "none !important",
              },
            }}
          >
            {newsList()}
          </Carousel>
        </ThemeProvider>
        <div className="muvika-home-panel">
          <h3>{TR.cm_trending_tracks}</h3>
          <HorizontalContainer minWidth={trendingTracks ? trendingTracks.length * 171 : 0}>
            {renderTopTracks()}
          </HorizontalContainer>
        </div>
        <div className="muvika-home-panel">
          <h3>{TR.cm_recommended_playlists}</h3>
          <HorizontalContainer minWidth={publicPlaylists ? publicPlaylists.length * 171 : 0}>
            {renderPublicPlaylists()}
          </HorizontalContainer>
        </div>
        {renderTrackList()}
      </ContentContainer>
    </div >
  );
}

export default Home;